import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" clip-path=\"url(#i1939827615__a)\"><path fill=\"currentColor\" d=\"M12.667 7.833H3.333C2.597 7.833 2 8.43 2 9.166v4.667c0 .736.597 1.333 1.333 1.333h9.334c.736 0 1.333-.597 1.333-1.333V9.166c0-.736-.597-1.333-1.333-1.333\"></path><path stroke-width=\"2\" d=\"M4.667 7.833V5.166a3.333 3.333 0 0 1 6.666 0v2.667\"></path></g><defs><clipPath id=\"i1939827615__a\"><path fill=\"currentColor\" d=\"M0 .5h16v16H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }